import Head from '@/components/head'
import Footer from '@/components/footer'
export default {
    install(Vue, options) {
        Vue.component('Head', Head);
        Vue.component('Footer', Footer);
    }
}



// WEBPACK FOOTER //
// ./src/components/components.js